export const GOAL_TIER_IDS = ['essential', 'support', 'context'];

export const MAX_GOALS_PROFILE = 8;

export const GOAL_TIER_META = [
  {
    id: 'essential',
    rank: 1,
    title: 'Essencial',
    hint: 'Prioridade máxima — define o foco principal do plano',
    triggerEmpty: 'Adicionar objetivos essenciais',
  },
  {
    id: 'support',
    rank: 2,
    title: 'Suporte',
    hint: 'Relevância média — saúde, mobilidade e foco anatômico',
    triggerEmpty: 'Adicionar objetivos de suporte',
  },
  {
    id: 'context',
    rank: 3,
    title: 'Contexto',
    hint: 'Complementar — rotina, tempo, equipamento e estilo',
    triggerEmpty: 'Adicionar contexto de treino',
  },
];

export function emptyGoalTiers() {
  return { essential: [], support: [], context: [] };
}
